import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import SoftSelect from '../../../../components/SoftSelect';
import { policyCancellationSubmissionReasons } from '../const/policyCancellationSubmissionReasons';

const SubmissionReasonSelect = ({
  value,
  onChange,
  className,
  isDisabled = false,
  required = false,
}) => {
  const { t } = useTranslation();

  // Examples are shown only in the open menu; the selected value shows the category alone.
  const formatOptionLabel = (option, { context }) =>
    context === 'menu' ? (
      <Box>
        <Typography variant="body2">{option.label}</Typography>
        <Typography
          variant="caption"
          color="grey.600"
          sx={{ display: 'block', whiteSpace: 'normal' }}
        >
          {t(option.examples)}
        </Typography>
      </Box>
    ) : (
      option.label
    );

  return (
    <Box className={className}>
      <Typography variant="body2" sx={{ mb: 0.5 }}>
        {t('POLICY_CANCELLATION.label.submissionReason')}
        {required && <span aria-hidden="true"> *</span>}
      </Typography>
      <SoftSelect
        placeholder={t('POLICY_CANCELLATION.selectPlaceholder.reason')}
        options={policyCancellationSubmissionReasons}
        value={value}
        onChange={onChange}
        isDisabled={isDisabled}
        isClearable
        formatOptionLabel={formatOptionLabel}
      />
    </Box>
  );
};

SubmissionReasonSelect.propTypes = {
  className: PropTypes.string,
  value: PropTypes.object,
  onChange: PropTypes.func,
  isDisabled: PropTypes.bool,
  required: PropTypes.bool,
};

export default SubmissionReasonSelect;
